import { string, shape, bool } from 'prop-types';

export const VersionsType = shape({
    spaceId: string,
    number: string,
    showInList: bool
});
